import { WorkflowWidgetEventDataType, WorkflowWidgetEventNames } from './events.enums';

class EventNameMapper {
  static eventNameRegistries = {};
  constructor() {
    this.Add(WorkflowWidgetEventNames.ApplicationSubmit, WorkflowWidgetEventDataType.LoanEventData);
    this.Add(WorkflowWidgetEventNames.LoanCreated, WorkflowWidgetEventDataType.LoanEventData);

    this.Add(WorkflowWidgetEventNames.BundleCreated, WorkflowWidgetEventDataType.BundleEventData);
    this.Add(WorkflowWidgetEventNames.BundleLoaded, WorkflowWidgetEventDataType.BundleEventData);

    this.Add(WorkflowWidgetEventNames.NextButtonClicked, WorkflowWidgetEventDataType.NavigationEventData);
    this.Add(WorkflowWidgetEventNames.PreviousButtonClicked, WorkflowWidgetEventDataType.NavigationEventData);
  }

  private Add(eventName: WorkflowWidgetEventNames, eventDataType: WorkflowWidgetEventDataType) {
    EventNameMapper.eventNameRegistries[eventName] = eventDataType;
  }

  public getEventDataType(eventName: WorkflowWidgetEventNames): WorkflowWidgetEventDataType {
    const eventDataType = EventNameMapper.eventNameRegistries[eventName];
    if (!eventDataType) {
      throw Error(`Event Name ${eventName} was not registered in EventNameMapper.eventNameRegistries`);
    }

    return eventDataType;
  }
}

export const eventMapper = new EventNameMapper();
